/*
 * IESA Cosmic Frequency Orb — Web Audio playback
 *
 * Plays Solfeggio frequencies (432/528/963 Hz) when a .cosmic-freq-key
 * button is clicked. Tone fades in over 150ms, sustains, fades out over 500ms.
 *
 * Why this lives in /assets and not inline in the section custom_liquid:
 *   - Inline <script> inside a custom-liquid section interferes with the
 *     Shopify theme editor's section hot-reload (postMessage signaling),
 *     which caused v8/v9 to hang on the editor loading screen.
 *   - Loaded as an asset via {{ 'cosmic-orb.js' | asset_url | script_tag }},
 *     this runs once per page with no editor interference.
 *
 * The script is defensive: returns silently if no orb is present on the page,
 * and re-binds on shopify:section:load for editor live preview.
 */
(function () {
  'use strict';

  function init() {
    var keys = document.querySelectorAll('.cosmic-freq-key[data-freq]');
    if (!keys.length) return;

    var stage = document.querySelector('[data-cosmic-orb]');
    var ctx, oscillator, gainNode, stopTimer;

    function play(hz) {
      try {
        if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
        if (ctx.state === 'suspended') ctx.resume();
        stopSound();
        oscillator = ctx.createOscillator();
        gainNode = ctx.createGain();
        oscillator.type = 'sine';
        oscillator.frequency.value = hz;
        gainNode.gain.value = 0;
        oscillator.connect(gainNode).connect(ctx.destination);
        oscillator.start();
        var now = ctx.currentTime;
        gainNode.gain.linearRampToValueAtTime(0.08, now + 0.15);
        gainNode.gain.setValueAtTime(0.08, now + 3.5);
        gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 4);
        stopTimer = setTimeout(stopSound, 4100);
      } catch (e) {
        // Browser blocked Web Audio (autoplay policy, iframe sandbox, etc.) — fail silently
        if (window.console) console.warn('Cosmic orb: audio unavailable', e);
      }
    }

    function stopSound() {
      clearTimeout(stopTimer);
      if (oscillator) {
        try { oscillator.stop(); oscillator.disconnect(); } catch (e) {}
        oscillator = null;
      }
      if (gainNode) {
        try { gainNode.disconnect(); } catch (e) {}
        gainNode = null;
      }
      if (stage) stage.classList.remove('is-playing');
      keys.forEach(function (k) { k.classList.remove('is-playing'); });
    }

    keys.forEach(function (key) {
      if (key.dataset.cosmicBound) return;
      key.dataset.cosmicBound = '1';
      key.addEventListener('click', function () {
        if (key.classList.contains('is-playing')) {
          stopSound();
          return;
        }
        keys.forEach(function (k) { k.classList.remove('is-playing'); });
        key.classList.add('is-playing');
        if (stage) stage.classList.add('is-playing');
        play(parseFloat(key.dataset.freq));
      });
    });

    if (!window.__cosmicOrbPageHideBound) {
      window.__cosmicOrbPageHideBound = true;
      window.addEventListener('pagehide', stopSound);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Rebind when theme editor reloads sections during live customization
  document.addEventListener('shopify:section:load', init);
})();
